export default __webpack_public_path__ + "static/media/delete.icon.f585f600.svg";